<template>
    <div class="help-center-content">
        <h4>了解平台</h4>
        <p class="title">1.  作品有声化平台是什么？</p>
        <p class="content">作品有声化平台，是一个连接作家、出版社、主播以及音频制作人的资源撮合平台。在这里，大家将会一起创造优秀的有声作品，用声音为文字创造新价值。 首先，作家或出版社会向平台提供有版权的内容，并以发布任务的形式寻找合适的主播进行录制。接着，主播会根据要求完成作品录制。最后，由后期制作人处理音频。</p>
        <p class="title">2.  我能在作品有声化平台做些什么？</p>
        <p class="content">在这里，你可以找到海量优质内容，尽情演绎作品，为喜马拉雅4亿用户创造悦耳的聆听享受。不仅可以获得可观的收益，还能聚集人气，形成个人影响力喔。</p>
        <p class="title">3.  在作品有声化平台，有哪些赚取收益的方式？</p>
        <p class="content">作品有声化平台的收益来源有：录制佣金、付费作品分成和广告收益。</br>
            当按照要求完成有声作品录制后，您就能获得事先约定的佣金，佣金以录制时间为计算单位。除了佣金外，部分有声作品会在喜马拉雅上定价售卖或承接广告，因此你也能获得一定比例的付费作品分成和广告收益。内容质量越好的有声作品，越容易获得这些额外收益呢。
        </p>
        <p class="title">4.  平台联系方式</p>
        <p class="content">
            <strong>有声化平台官方邮箱：a.plus@ximalaya.com。</strong><br>
            有任何疑问和建议，请通过邮箱与我们联系，我们将竭诚为您服务
        </p>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        components: {
        },
        data() {
            return {

            }
        },
        computed: {

        }
    }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// AnchorAboutPlatForm.vue?263a7102